import { AccountInfo } from "@azure/msal-browser";

export const getAccountName = (account: AccountInfo) => {
    let name = account.name;
    if (!name || name === 'unknown') {
        name = `${account.idTokenClaims!.given_name} ${account.idTokenClaims!.family_name}`
    }

    return name;
} 